import React from "react";
import {Box, IconButton, Stack} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {ArrowLeft01Icon, ArrowRight01Icon} from "@hugeicons/core-free-icons";

const arrowSx = {
  width: 28,
  height: 28,
  borderRadius: "50% !important",
  bgcolor: "#fff",
  color: "#4A4A63",
  boxShadow: "0 1px 5px rgba(35, 38, 77, 0.18)",
  "&:hover": {bgcolor: "#F4F4FA"},
  "&.Mui-disabled": {bgcolor: "#fff", opacity: 0.4},
};


export const CarouselNav = ({count, index, onPrev, onNext, onGo}) => {
  if (count < 2) return null;
  return (
    <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} sx={{mt: 1.5}}>
      <IconButton size={"small"} sx={arrowSx} disabled={index <= 0} onClick={onPrev} aria-label={"Previous card"}>
        <HugeiconsIcon icon={ArrowLeft01Icon} size={15}/>
      </IconButton>

      <Stack direction={"row"} alignItems={"center"} gap={0.75}>
        {Array.from({length: count}).map((_, i) => (
          <Box
            key={i}
            component={"button"}
            type={"button"}
            onClick={() => onGo(i)}
            aria-label={`Go to card ${i + 1} of ${count}`}
            aria-current={i === index}
            sx={{
              p: 0, border: 0, cursor: "pointer", height: 6, borderRadius: 3,
              width: i === index ? 18 : 6,
              bgcolor: i === index ? "#8491F7" : "#C9CAD8",
              transition: "width 0.2s, background-color 0.2s",
            }}
          />
        ))}
      </Stack>

      <IconButton size={"small"} sx={arrowSx} disabled={index >= count - 1} onClick={onNext} aria-label={"Next card"}>
        <HugeiconsIcon icon={ArrowRight01Icon} size={15}/>
      </IconButton>
    </Stack>
  );
};
